import { render } from "./LuckyCodesList.vue?vue&type=template&id=706d6b4a&bindings={}"
import script from "./LuckyCodesList.vue?vue&type=script&lang=ts"
export * from "./LuckyCodesList.vue?vue&type=script&lang=ts"

import "./LuckyCodesList.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script